import React from 'react'

import {connect} from 'react-redux'
import {fetchGroup, updateGroup} from '../../actions/group-actions'
import {removeLocation, upsertLocation} from '../../actions/location-actions'
import {loadDeletedLocations} from '../../actions/revision-actions'
import {fetchGroupMemberships, updateMembership} from '../../actions/membership-actions'
import {removeUserMembership} from '../../actions/group-actions'
import {Link} from 'react-router-dom'

import {Grid, Overlay, Popover, Row, Table} from 'react-bootstrap'
import {isEmpty, set} from 'lodash'

import FontAwesome from 'react-fontawesome'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'

import Breadcrumbs from '../../components/Breadcrumbs'
import SearchBar from '../../components/SearchBar'
import NotesOverview from '../../components/NotesOverview'
import PropertyTitle from '../../components/PropertyTitle'
import Property from '../../components/Property'
import ConfirmModal from '../../components/ConfirmModal'
import IpRangeModal from '../../components/IpRangeModal'
import LicenseTable from '../../components/LicenseTable'
import NotFound from '../NotFound'
import RevisionsPopup from '../../components/RevisionsPopup'
import RevisionTable from '../../components/RevisionTable'
import ExportVisitCountInput from '../../components/ExportVisitCountInput'
import SchacHomeOrganizationInput from "../../components/SchacHomeOrganizationInput";
import * as Util from '../../services/util'

const Checkbox = ({ checked, onChange }) => (
  <label className="toggle">
    <span className="label">{checked && 'Beheerder'}</span>
    <Toggle
      checked={checked}
      icons={{
        checked: null,
        unchecked: null,
      }}
      onChange={onChange}
    />
  </label>
)

class GroupDetail extends React.Component {
  constructor() {
    super()
    this.state = { showDeleted: false , nameOrdering: 'asc', IPOrdering: null }
    this.onSave = this.onSave.bind(this);
    const ipQueryParam = new URLSearchParams(document.location.search).get('selectedIp');
    this.selectedIp = ipQueryParam && Util.validateIpAddress(ipQueryParam) ? ipQueryParam : '';
  }

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(oldProps) {
    if (this.props.match.params.id !== oldProps.match.params.id) {
      this.props.fetchGroup(this.match.params.id)
      this.props.fetchGroupMemberships(this.match.params.id)
    }
  }

  search(query) {
    this.props.history.push(`/groepen?query=${query}`)
  }

  removeLocation(id) {
    this.props.removeLocation(id).then(() => {
      this.reload()
    });
  }

  removeUserMembership(groupId, userId) {
    console.log(groupId)
    console.log(userId)
    this.props.removeUserMembership(groupId, userId).then(() => {
      this.reload()
    });
  }

  upsertLocation(location) {
    return this.props.upsertLocation(location)
  }

  reload() {
    this.props.fetchGroup(this.props.match.params.id)
    this.props.fetchGroupMemberships(this.props.match.params.id)
  }

  toggleAdmin(m) {
    let membership = m
    membership.admin = !m.admin
    this.props.updateMembership(membership).then(() => this.reload())
  }

  onSave(property, value) {
    let group = this.props.group
    set(group, property, value)
    this.props.updateGroup(group).then(() => {
      this.reload()
    })
  }

  loadDeleted() {
    this.props.loadDeletedLocations(this.props.group.id)
    this.setState({ showDeleted: true })
  }

  fullName(user) {
    let fullName = null
    if (user.firstName == null && user.lastName == null) {
      fullName = user.userId
    } else if (user.firstName == null) {
      fullName = user.lastName
    } else if (user.lastName == null) {
      fullName = user.firstName
    } else {
      fullName = `${user.firstName} ${user.lastName}`
    }
    return fullName
  }

  orderByName(locations){
    let sortedLocations = locations
    this.setState({ IPOrdering: null })

    if(this.state.nameOrdering === 'desc' || this.state.nameOrdering === null) {
        this.setState({ nameOrdering: 'asc' })
        sortedLocations.sort(this.dynamicSort('name'))
    } else {
        this.setState({ nameOrdering: 'desc' })
        sortedLocations.sort(this.dynamicSort('-name'))
    }
  }

  orderByIP(locations){
     this.setState({ nameOrdering: null })
     let sortedLocations = locations
     if(this.state.IPOrdering === 'desc' || this.state.IPOrdering === null) {
        this.setState({ IPOrdering: 'asc' })
        sortedLocations.sort(this.ipSort('ipAddressFrom'))
     } else {
        this.setState({ IPOrdering: 'desc' })
        sortedLocations.sort(this.ipSort('-ipAddressFrom'))
    }
  }

  dynamicSort(property) {
      var sortOrder = 1;
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function (a,b) {
          var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
      }
  }

  ipSort(property){
      var sortOrder = 1;
      if(property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function(a,b){
         let ipNumberA = a[property].split('.').map(function(x) {
                        return x.padStart(3, "0");
                      }).join('');
         let ipNumberB = b[property].split('.').map(function(x) {
                                             return x.padStart(3, "0");
                                           }).join('');
         var result = (ipNumberA < ipNumberB) ? -1 : (ipNumberA > ipNumberB) ? 1 : 0;
         return result * sortOrder;
      }
  }

  render() {
    const { group, memberships, locations } = this.props
    if (group && group.id === -1) {
      return <NotFound />
    }
    if (isEmpty(group) || group.id !== parseInt(this.props.match.params.id, 10)) {
      return null
    }

    return (
      <Grid>
        <Breadcrumbs title={group.name} />
        <SearchBar placeholder="Zoek op naam of IP-adres" callback={(query) => this.search(query)} />

        <Row>
          <div className="content">
            <div>
              <span className="title" data-group-id={this.props.match.params.id}>
                <b>Groep</b>
              </span>
            </div>
            <div>
              <PropertyTitle icon="users" text={group.name} />
              <Property
                icon="building-o"
                value={<><Link to={`/klanten/${group.customer.id}`}>{group.customer.name}</Link> {group.customer.navisionCustomerId != null ? '- ' + group.customer.navisionCustomerId : ''}</>}
              />
              <Property icon="dot-circle-o" value={group.uuid} />
              <br />
            </div>
            <div>
              <PropertyTitle small icon="users" text="Maximaal aantal gebruikers" />
              <div className="tablescontainer">
                <p>{group.maxMembers != null ? group.maxMembers : 'Geen maximum opgegeven'}</p>
              </div>
            </div>
            <div>
              <PropertyTitle small icon="users" text="Huidig aantal gebruikers" />
              <div className="tablescontainer">
                <p>{memberships.length}</p>
              </div>
            </div>
            <SchacHomeOrganizationInput currentSchacHomeOrganization={group.schacHomeOrganization} onSave={this.onSave}/>
            <LicenseTable history={this.props.history} licenses={group.licenses} />
            <div>
              <PropertyTitle small icon="location-arrow" text="IP-Ranges" />
              <div className="tablescontainer">
                {locations.length > 0 ? (
                  <Table striped>
                    <thead>
                      <tr>
                        <th onClick={() => this.orderByName(locations)}>Naam
                        {this.state.nameOrdering === 'asc' ?
                            <FontAwesome className="sort-up" name="sort-up" size="lg" onClick={() => this.orderByName(locations)} /> :
                                this.state.nameOrdering === 'desc' ?
                                <FontAwesome className="sort-down" name="sort-down" size="lg" onClick={() => this.orderByName(locations)} /> : ''
                                }
                        </th>
                        <th onClick={() => this.orderByIP(locations)}>Van
                        {this.state.IPOrdering === 'asc' ?
                            <FontAwesome className="sort-up" name="sort-up" size="lg" onClick={() => this.orderByIP(locations)} /> :
                                this.state.IPOrdering === 'desc' ?
                                <FontAwesome className="sort-down" name="sort-down" size="lg" onClick={() => this.orderByIP(locations)} /> : ''
                                }
                        </th>
                        <th>Tot</th>
                        <th>Overlapt met</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {locations.map((location, index) => (
                        <tr className={this.selectedIp && Util.isIpInRange(this.selectedIp, location.ipAddressFrom, location.ipAddressTo) ?
                          "selected-location" : "location"} key={index}>
                          <td >{location.name}</td>
                          <td>{location.ipAddressFrom}</td>
                          <td>{location.ipAddressTo}</td>
                          <td>
                            <ul>
                              {location.overlappingLocations.map((l) => (
                                <li>
                                  <a href={`/groepen/${l.group.id}`}>
                                    <b>{l.name}</b> van groep <b>{l.group.name}</b>
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td className="options">
                            <span id={location.name}>
                              <RevisionsPopup
                                entity="location"
                                entityId={location.id}
                                property="ipAddressFrom,ipAddressTo"
                                type="ip-range"
                              />
                            </span>
                            <FontAwesome
                              className="delete"
                              name="trash"
                              size="lg"
                              onClick={() => this.confirmModal.show(() => this.removeLocation(location.id))}
                            />
                            <FontAwesome
                              className="edit"
                              name="pencil"
                              size="lg"
                              onClick={() => this.ipRangeModal.edit(location)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p>Geen IP-ranges</p>
                )}
                <FontAwesome
                  className="add-location"
                  name="plus"
                  size="lg"
                  onClick={() => this.ipRangeModal.add(group)}
                />
                <FontAwesome
                  className="location-history"
                  id="history-location"
                  name="history"
                  size="lg"
                  onClick={() => this.loadDeleted()}
                  ref="target"
                />
                <Overlay
                  placement="bottom"
                  rootClose
                  show={this.state.showDeleted}
                  target={this.refs.target}
                  onHide={() => this.setState({ showDeleted: false })}
                >
                  <Popover style={{ maxWidth: 1280 }} title="Verwijderde IP-Ranges" id="dl">
                    <RevisionTable type="deleted-location" revisions={this.props.deletedLocations} />
                  </Popover>
                </Overlay>
              </div>
            </div>
            <div>
              <PropertyTitle small icon="users" text="Gebruikers" />
              <div className="tablescontainer">
                {memberships.length > 0 ? (
                  <Table striped>
                    <thead>
                      <tr>
                        <th>Naam</th>
                        <th>Beheerder</th>
                        <th />
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {memberships.map((membership, index) => {
                        const user = membership.user
                        return (
                          <tr className="user" key={index}>
                            <td onClick={() => this.props.history.push(`/gebruikers/${user.id}`)}>
                              {this.fullName(user)}
                            </td>
                            <td className="admin">
                              <Checkbox checked={membership.admin} onChange={(e) => this.toggleAdmin(membership)} />
                            </td>
                            <td className="admin">
                              <FontAwesome
                                  className="delete"
                                  name="trash"
                                  size="lg"
                                  onClick={() => this.membershipModal.show(() => this.removeUserMembership(group.uuid, user.userId))}
                                />
                            </td>
                            <td className="options">
                              <RevisionsPopup
                                entity="membership"
                                entityId={membership.id}
                                property="admin"
                                type="boolean"
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <p>Geen gebruikers</p>
                )}
              </div>
            </div>
            <NotesOverview group={group} />
            <ExportVisitCountInput group={group} />
          </div>
        </Row>
        <ConfirmModal
          ref={(ref) => (this.confirmModal = ref)}
          message="Weet je zeker dat je deze IP-Range wilt verwijderen?"
        />
        <IpRangeModal
          ref={(ref) => (this.ipRangeModal = ref)}
          reload={() => this.reload()}
          onSave={(location) => this.upsertLocation(location)}
        />
        <ConfirmModal
          ref={(ref) => (this.membershipModal = ref)}
          message="Weet je zeker dat je dit gebruikerslidmaatschap wilt verwijderen?"
        />
      </Grid>
    )
  }
}

export default connect(
  (state) => {
    return {
      group: state.groups.detail.group ? state.groups.detail.group.group : {},
      locations: state.groups.detail.group ? state.groups.detail.group.locations : {},
      memberships: state.memberships.forGroup,
      deletedLocations: state.revisions.locations,
    }
  },
  {
    fetchGroup,
    fetchGroupMemberships,
    updateGroup,
    updateMembership,
    removeLocation,
    upsertLocation,
    loadDeletedLocations,
    removeUserMembership
  }
)(GroupDetail)
